export default __webpack_public_path__ + "static/media/icon-cross.0330fcc9.svg";